import { useSelector } from 'react-redux';
import { specialistsFiltersValuesSelector } from 'src/redux/specialists/selector';
import { useCallback, useMemo } from 'react';
import { FiltersDataForAnalytics } from '../types/filters';
import { FilterValue, LocaleCurrencyMapper, SupportedCurrency } from '@mindly/ui-components';
import { userSelector } from 'src/redux/user/selector';

export const useFilters = () => {
  const filtersValues = useSelector(specialistsFiltersValuesSelector);
  const currentUser = useSelector(userSelector);

  const getFiltersDataForAnalytics = useCallback(
    (values: Record<string, FilterValue>) => ({
      ...Object.entries(values).reduce(
        (acc, [key, value]) => {
          switch (key) {
            case 'session_price':
              if (Array.isArray(value) && value.length === 2) {
                acc.filters_price_min = Number(value[0]);
                acc.filters_price_max = Number(value[1]);
              }
              break;
            case 'sex':
              acc.filters_gender =
                Array.isArray(value) && (value.length === 2 || value.length === 0)
                  ? 'any'
                  : Array.isArray(value)
                    ? (value[0] as 'male' | 'female')
                    : 'any';
              break;
            case 'specialization':
              if (Array.isArray(value) && value.length > 0) {
                acc.filters_specializations = value as string[];
              }
              break;
            case 'areas_of_work':
              if (Array.isArray(value) && value.length > 0) {
                acc.filters_work_direction = value as string[];
              }
              break;
            case 'areas_of_work_by_client_problem':
              if (Array.isArray(value) && value.length > 0) {
                acc.filters_help_situation = value as string[];
              }
              break;
            case 'localized_areas_of_work_by_client_problem':
              if (Array.isArray(value) && value.length > 0) {
                acc.filters_help_situation = value as string[];
              }
              break;
            case 'super_specialist':
              if (value) {
                acc.filters_tags_selected = acc.filters_tags_selected || [];
                acc.filters_tags_selected.push('Super specialist');
              }
              break;
            case 'activated_at':
              if (value) {
                acc.filters_tags_selected = acc.filters_tags_selected || [];
                acc.filters_tags_selected.push('New specialist');
              }
              break;
          }
          return acc;
        },
        {
          filters_currency:
            LocaleCurrencyMapper[currentUser?.app_lang as keyof typeof LocaleCurrencyMapper] ?? SupportedCurrency.UAH,
        } as FiltersDataForAnalytics
      ),
    }),
    [currentUser?.app_lang]
  );

  const filtersDataForAnalytics = useMemo(
    () => getFiltersDataForAnalytics(filtersValues),
    [filtersValues, getFiltersDataForAnalytics]
  );

  const filtersVersion = useMemo(() => {
    return 'v2';
  }, []);

  return {
    filtersDataForAnalytics,
    getFiltersDataForAnalytics,
    filtersVersion,
  };
};
